const features = [
  {
    icon: 'ri-speed-up-fill',
    title: '极速加载 流畅不卡顿',
    desc: '采用智能CDN加速与多线路切换技术，无论何时何地都能享受丝滑流畅的高清观影体验，告别缓冲等待。',
    color: 'bg-primary-100 text-primary-500',
  },
  {
    icon: 'ri-shield-check-fill',
    title: '纯净观影 零广告干扰',
    desc: '坚持简约纯净的播放界面设计，无弹窗、无贴片广告、无强制跳转，让你全身心沉浸在影视世界中。',
    color: 'bg-accent-100 text-accent-500',
  },
  {
    icon: 'ri-stack-fill',
    title: '海量资源 每日同步更新',
    desc: '覆盖电视剧、电影、综艺、动漫等多种类型，每日同步更新最新剧集和热门大片，资源全面且时效性高。',
    color: 'bg-secondary-100 text-secondary-500',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            平台优势
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-extrabold text-foreground-900">
            为什么选择棒棒TV
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            三大核心优势，打造极致的在线观影平台
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {features.map((feature, idx) => (
            <div
              key={idx}
              className="group bg-background-50 rounded-xl border border-background-200/70 p-6 md:p-8 text-center hover:border-primary-200 transition-all duration-300"
            >
              <div className={`w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl ${feature.color} mx-auto mb-5 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${feature.icon} text-2xl md:text-3xl`}></i>
              </div>
              <h3 className="font-heading font-bold text-lg md:text-xl text-foreground-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-sm md:text-base text-foreground-500 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}